module.exports = __webpack_public_path__ + "img/hs.d199c3d7.png";